import Flex from 'components/Flex'
import { StyledTabs } from 'components/TabsPaneStyles'
import styled from 'styled-components'
import { COLORS } from 'theme/index'
export const FlexWrapper = styled(Flex)``
export const CandidatesSpan = styled.span`
  padding: 2px 6px;
  margin-left: 10px;
  width: 29px;
  height: 19px;
  background: ${COLORS.PAGE_BORDER};
  border-radius: 20px;
`

export const StyledTab = styled(StyledTabs)`
  .ant-tabs-tab {
    padding: 15px 0 !important;
  }
  .ant-tabs-nav {
    width: 100% !important;
    margin: 0 !important;
  }
  .ant-tabs-tab-btn {
    color: ${COLORS.GREY_T_50_2};
    text-shadow: 0 0 0.25px currentcolor;
  }
  .ant-tabs-ink-bar {
    background: ${COLORS.PRIMARY} !important;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${COLORS.PRIMARY};
  }

  width: 100%;
  .ant-tabs-content {
    height: 250px !important;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`
